<template>
  <div>
    <Head @langChange="langSelect" />
    <section
      class="gameTop TopWarp"
      :style="{
        'background-color': '' + TopBgColor + '',
      }"
    >
      <img :src="TopUrl" alt="" />
      <div class="cont">
        <p class="p1" v-if="TopTitle != ''">{{ TopTitle }}</p>
        <p v-if="TopContent != ''">{{ TopContent }}</p>
      </div>
    </section>
    <section class="contactWarp cl">
      <div class="title">联系我们</div>
      <div class="main cl">
        <div class="items" v-for="(item, index) in ContList" :key="index">
          <div class="item cl">
            <div class="z icon">
              <!-- <i class="iconfont" :class="item.icon"></i> -->
              <img :src="item.icon" alt="" />
            </div>
            <div class="z info">
              <div class="tit">{{ item.title }}</div>
              <div class="cont">
                <pre v-html="item.contact_info"></pre>
                <!-- <p v-for="(i, index) in item.contact_info" :key="index">
                  {{ i.txt }}
                </p> -->
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <!-- 底部footer -->
    <Foot ref="foot"></Foot>
  </div>
</template>

<script>
import { mapState } from "vuex";
import Head from "@/components/head.vue";
import Foot from "@/components/Foot.vue";
import { getContactUs } from "@/common/api.js";

export default {
  name: "Content",
  components: {
    Head,
    Foot,
    getContactUs,
  },
  data() {
    return {
      TopUrl: "",
      TopBgColor: "",
      TopTitle: "",
      TopContent: "",
      ContList: [],
      lang: this.$route.query.language || "zh",
    };
  },
  created() {
    this.getContact();
  },
  mounted() {},
  methods: {
    getContact() {
      let that = this;
      getContactUs({
        language: that.lang,
      }).then((res) => {
        if (res.status == 200) {
          let Data = res.data.data;
          that.TopUrl = Data.TopUrl;
          that.TopBgColor = Data.TopBgColor;
          that.TopTitle = Data.TopTitle;
          that.TopContent = Data.TopContent;
          that.ContList = Data.ContList;
        } else {
          console.log(res.statusText);
        }
      });
    },
    langSelect: function (param) {
      this.lang = param;
      this.getContact();
      this.$refs.foot.langSelect(param);
    },
  },
  computed: {
    // ...mapState({
    //   lang: (state) => state.lang,
    // }),
  },
};
</script>

<style scoped>
.contactWarp .info {
  line-height: 1.2;
}
.icon {
  overflow: hidden;
}
</style>



























































// WEBPACK FOOTER //
// src/views/Contact.vue